<style lang="scss">
$leftWidth: 220px;

.applyInForm {
  .content-part {
    .content-left {
      width: 0;
    }

    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
    }
  }

  .el-checkbox--upload {
    position: absolute;
    left: 100px;
    top: 0;
    display: block;
  }

  .level-pic {
    margin-left: 100px;
    margin-right: 20px;
    margin-bottom: 16px;
    background: #eee;
    min-height: 160px;
    padding-top: 40px;
    position: relative;

    &-li {
      position: absolute;
      right: 0;
      bottom: 0;
    }

    &-title {
      line-height: 22px;
      padding-left: 12px;
    }
  }

  .level-table {
    margin-right: 20px;
    margin-left: 100px;

    .el-input__inner {
      height: 22px;
    }
  }
}
</style>
<template>
  <div class="applyInForm">
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3>替换追溯码</h3>
        <div class="hide-content show-content">
          <el-form ref="form" :rules="rules" :model="form"
                   label-width="0px" style="padding-right: 20px">
            <el-table border :data="formTable">
              <el-table-column label="原追溯码" prop="oldCode">
                <template slot-scope="scope">
                  <el-input v-model.trim="scope.row.oldCode"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="新追溯码" prop="newCode">
                <template slot-scope="scope">
                  <el-input v-model.trim="scope.row.newCode"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <el-button @click="handleFormTableAdd(scope)">新增</el-button>
                  <el-button v-if="formTable.length !== 1" @click="handleFormTableDelete(scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>


          <div style="margin-top: 16px; padding-left: 0px;">
            <el-button type="primary" :loading="doing" @click="handleCodeAdd">开始替换</el-button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {http, resourceCode, traceCode} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';
import ManageChildrenGoodsOption from '@/components/common/select/option-child-manage-goods.vue';

export default {
  components: {ManageChildrenGoodsOption},
  props: ['defaultIndex'],
  mixins: [methodsMixin],
  data() {
    return {
      formTable: [{newCode: '', oldCode: ''}],
      standItem: {newCode: '', oldCode: ''},

      tabledatas: [],
      form: {
        goodsId: '',
        batchNumberIdList: [],
        productSubclassId: '',
        childBatchNumberIdList: [],
        attachmentIdList: [],
        model: 0
      },
      rules: {
        goodsId: {required: true, message: '请选择货品', trigger: 'change'},
        productSubclassId: {required: true, message: '请选择包装比例', trigger: 'change'},
      },
      doing: false,
      fileList: [],
      isUploading: false,
      isChecked: false,
      uploadingFiles: null
    };
  },
  computed: {
    colorList() {
      return this.$store.state.colorList;
    },
    currentGoods() {
      return this.manageGoods.filter(f => f.goodsId === this.form.goodsId)[0] || {};
    },
    currentChildrenGoods() {
      let newList = JSON.parse(JSON.stringify(this.manageChildrenGoods))
      return newList.find(f => f.productSubclassId === this.form.productSubclassId);
    },
    uploading() {
      return this.uploadingFiles && this.uploadingFiles.percentage < 100;
    }
  },
  watch: {
    defaultIndex(val) {
      this.$refs.form.resetFields();
      this.resetForm();
    }
  },
  methods: {
    resetTable() {
      this.formTable = [JSON.parse(JSON.stringify(this.standItem))];
    },
    handleFormTableAdd(scope) {
      this.formTable.splice(scope.$index + 1, 0, JSON.parse(JSON.stringify(this.standItem)));
    },
    handleFormTableDelete(scope) {
      this.formTable.splice(scope.$index, 1);
    },
    handleCodeAdd() {
      if (this.doing) return;
      if (this.formTable.find(f => f.newCode === '' || f.oldCode === '')) {
        return this.$notify.error({message: '替换的追溯码不能有空值'});
      }
      let repeat = false;
      this.formTable.map(item => {
        if (this.formTable.find(f => f.newCode === item.oldCode)) {
          repeat = true;
        }
      })
      if (repeat) return this.$notify.error({message: '新追溯码的内容不能包含有原追溯码'});
      if (this.$checkRepeat('newCode', this.formTable)) return this.$notify.error({message: '新追溯码不能重复'});
      if (this.$checkRepeat('oldCode', this.formTable)) return this.$notify.error({message: '旧追溯码不能重复'});
      this.doing = true;
      let list = [];
      this.formTable.map(m => {
        list.push({
          newTraceCode: m.newCode,
          oldTraceCode: m.oldCode
        })
      })
      traceCode.addReplace(list).then(res => {
        if (res.data === 400) return;
          this.$notify.success({
            message: '替换成功'
          });
          this.resetTable();
          this.tabledatas = [];
          this.$parent.close();
          this.$parent.$parent.getOrderList(1);
          this.doing = false;
      }).catch(e => {
        this.$notify.error({
          duration: 2000,
          message: this.$errHandler(e)
        });
        this.doing = false;
      })
    },
    handleCodeChange(val) {
      if (!val) {
        this.tabledatas.map((m) => {
          m.tab4 = 0;
        })
      } else {
        let firstCodesNum = parseFloat(val);
        this.tabledatas.map((m, index) => {
          if (index !== 0) {
            let times = this.tabledatas[0].packingCount;
            for (let i = 1; i <= index; i++) {
              times = times * this.tabledatas[i].packingCount
            }
            this.tabledatas[index].tab4 = firstCodesNum * times
          }
        })
      }
    },
    setIsUploading(val) {
      this.isUploading = val;
    },
    onUploadProgress(file) {
      this.setIsUploading(false);
      this.uploadingFiles = file;
    },
    changeFiles(files) {
      this.form.attachmentIdList = files.filter(f => f.attachmentId).map(m => m.attachmentId);
    },
    clearUploadFiles() {
      this.uploadingFiles = null;
    },
    queryGoodsBatchNumber(query) {
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')(query);
    },
    goodsChildrenChange(val) {
      console.log(val);
      if (!val) {
        this.tabledatas = [];
        return;
      }
      resourceCode.queryCode({productSubclassId: val}).then(res => {
        let newData = JSON.parse(JSON.stringify(res.data)).sort((a, b) => {
          return b.packingLevel - a.packingLevel
        });
        newData.map(m => {
          m.tab4 = 0
        });
        this.tabledatas = newData;
      })
    },
    goodsChange(val) {
      this.form.productSubclassId = '';
      this.tabledatas = [];

      this.manageChildrenGoods = [];
      this.form.batchNumberIdList = [];
      this.goodsBatchNumberList = [];
      if (!this.form.goodsId) return;
      this.queryGoodsNumber('form.goodsId')('');
    },
    resetForm() {
      this.form = {
        goodsId: '',
        batchNumberIdList: [],
        attachmentIdList: [],
        productSubclassId: '',
        model: 0
      };
      this.tabledatas = [];
      this.isChecked = false;
      this.fileList = [];
      this.isUploading = false;
      this.uploadingFiles = null;
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        if (!this.currentGoods.goodsTrackNo) {
          return this.$notify.info({
            message: '追溯码商品编号为空，请联系管理员'
          });
        }
        if (!this.form.attachmentIdList.length) {
          this.$notify.info({
            message: '请选择追溯码文件'
          });
          return;
        }
        this.form.type = 1;
        this.form.model = this.isChecked ? 1 : 0;
        this.doing = true;
        http.post('/code/org/parse/trace-code', this.form).then(res => {
          this.$emit('refresh', {id: res.data});
          this.resetForm();
          this.doing = false;
        }).catch(e => {
          this.$notify.error({
            duration: 2000,
            message: e.response && e.response.data && e.response.data.msg || '解析失败'
          });
          this.doing = false;
        });
      });
    }
  }
};
</script>
